export default __webpack_public_path__ + "media/images/bg_button_a-f00ab18d30853fcfc433a08cf767c628.gif";